/**
 * 파일 끌어놓기 화면 — 화면 전체를 흐리고 가운데 파일 묶음 그림 + 「파일을 놓아 주세요」. 순수 UI 다.
 * Figma 3-2 「놓기 화면」 · M3: 덮개 0→1 150ms ease-out, 타일 8px 위로 250ms ease-out.
 */
import { FilePdfColorIcon, MicrosoftOfficePowrpointColorIcon, MicrosoftOfficeWordColorIcon } from '@zep-us/zus-icons';
import { cn } from '@/utils/tailwind.util';

/** Figma 3-2 「파일 묶음」 — 64×76 흰 카드 3장을 14 겹치고 양 끝 카드만 ±10° 기울인다. */
const FILE_TILES = [{
  Icon: FilePdfColorIcon,
  tilt: '-rotate-[10deg]'
}, {
  Icon: MicrosoftOfficePowrpointColorIcon,
  tilt: 'rotate-0'
}, {
  Icon: MicrosoftOfficeWordColorIcon,
  tilt: 'rotate-[10deg]'
}] as const;
export const AiGenerateDockFileDropOverlay = ({
  message,
  placement = 'fixed'
}: {
  message: string;
  placement?: 'fixed' | 'static';
}) => <div data-testid="ai-generate-dock-file-drop" role="status" className={cn(placement === 'fixed' ? 'fixed' : 'absolute',
// 묶음과 문구 사이 20 — Figma 3-2 값(spacing 토큰에 20 이 없다).
'inset-0 z-50 flex flex-col items-center justify-center gap-[20px] bg-gray-50/80 backdrop-blur-[6px]', 'animate-in fade-in duration-150 ease-out motion-reduce:animate-none')} data-sentry-component="AiGenerateDockFileDropOverlay" data-sentry-source-file="AiGenerateDockFileDropOverlay.tsx">
    <div className="flex items-center ease-out animate-in slide-in-from-bottom-2 [animation-duration:250ms] motion-reduce:animate-none">
      {FILE_TILES.map(({
      Icon,
      tilt
    }) => <div key={tilt} aria-hidden className={cn(
    // 64×76 · 모서리 14 · 테두리 gray-100 · 그림자 0 8 20(shadow-xl) — Figma 3-2. 좌우 -7 씩 = 카드끼리 14 겹침.
    '-mx-[7px] flex h-[76px] w-[64px] items-center justify-center rounded-[14px] border border-gray-100 bg-default shadow-xl', tilt)}>
          <Icon className="size-[34px]" />
        </div>)}
    </div>
    <p className="text-heading-md-bold text-default">{message}</p>
  </div>;